<script lang="ts" setup>
import { FontAwesomeIcon, type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import type { BasicColor } from '@tailwind-preset/colors';
import { colorTextClasses } from '@tailwind-preset/colors';

const props = withDefaults(
  defineProps<{
    active?: boolean;
    color?: BasicColor;
    prefixIcon?: FontAwesomeIconProps['icon'];
    shadow?: boolean;
    suffixIcon?: FontAwesomeIconProps['icon'];
    inverted?: boolean;
    iconClass?: string;
  }>(),
  {
    active: undefined,
  },
);
</script>

<template>
  <button
    :class="[
      'whitespace-prewrap flex min-w-fit items-center gap-1.5 rounded border px-2.5 py-1.5 text-left text-sm text-primary-900',
      {
        'border-grey-200 bg-white': !props.inverted,
        'border-grey-100 bg-grey-100 transition-colors duration-100 hover:bg-grey-200':
          props.inverted,
        'shadow-[0_1px_2px_rgb(0_0_0_/_.1)]': props.shadow,
        'hover:border-grey-300 hover:bg-grey-100': !props.inverted && !props.shadow,
      },
    ]"
    type="button"
  >
    <FontAwesomeIcon v-if="props.prefixIcon" :icon="props.prefixIcon" fixed-width />
    <FontAwesomeIcon
      v-else-if="props.iconClass"
      icon="circle-small"
      fixed-width
      :class="props.iconClass"
    />
    <FontAwesomeIcon
      v-else-if="props.color"
      icon="circle-small"
      fixed-width
      :class="colorTextClasses[props.color]"
    />
    <slot></slot>

    <FontAwesomeIcon
      v-if="props.suffixIcon && props.active === undefined"
      class="ml-auto"
      :icon="props.suffixIcon"
    />

    <FontAwesomeIcon
      v-if="props.active !== undefined"
      :class="[
        'ml-auto text-primary transition-transform duration-100',
        {
          'translate-x-full opacity-0': !props.active,
          'translate-x-0 opacity-100': props.active,
        },
      ]"
      :icon="['far', 'check']"
    />
  </button>
</template>
